import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const DateDisplay = ({ date, format, nullValue, withTime }) => {
  if (date === null || date === undefined) return <>{nullValue}</>;
  if (withTime) {
    return <>{moment(date).format('YYYY-MM-DD [at] hh:mm A')}</>;
  }
  return <>{moment(date).format(format)}</>;
};

DateDisplay.defaultProps = {
  format: 'YYYY-MM-DD',
  nullValue: '-',
  withTime: false,
};

DateDisplay.propTypes = {
  date: PropTypes.number,
  format: PropTypes.string.isRequired,
  nullValue: PropTypes.string.isRequired,
  withTime: PropTypes.bool,
};

export default DateDisplay;
